import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createBlock as _createBlock, resolveDirective as _resolveDirective, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/chat/error-audio.svg'
import _imports_1 from '../../../assets/chat/download-default.svg'
import _imports_2 from '../../../assets/chat/download-focus.svg'
import _imports_3 from '../../../assets/chat/noVideo.svg'
import _imports_4 from '../../../assets/chat/noPicture.svg'
import _imports_5 from '../../../assets/chat/success-file.svg'
import _imports_6 from '../../../assets/chat/file-error.svg'
import _imports_7 from '../../../assets/chat/loading-file.svg'
import _imports_8 from '../../../assets/chat/map.svg'
import _imports_9 from '../../../assets/chat/locationMap.svg'
import _imports_10 from '../../../assets/chat/contactImg.svg'
import _imports_11 from '../../../assets/chat/defaultAvatar.svg'


const _withScopeId = n => (_pushScopeId("data-v-4be13b4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"width":"100%","display":"flex","justify-content":"center"}
}
const _hoisted_2 = { class: "bubbleType" }
const _hoisted_3 = {
  key: 0,
  style: {"align-self":"flex-start"}
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "leftAvatar"
}
const _hoisted_6 = {
  key: 0,
  class: "name"
}
const _hoisted_7 = {
  key: 1,
  class: "name"
}
const _hoisted_8 = { class: "leftBox" }
const _hoisted_9 = {
  key: 0,
  class: "username"
}
const _hoisted_10 = {
  key: 1,
  class: "username"
}
const _hoisted_11 = {
  key: 1,
  class: "audioType"
}
const _hoisted_12 = {
  key: 0,
  class: "errorAudio"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "errorImg"
}, null, -1))
const _hoisted_14 = { class: "errorTip wordRowsHidden" }
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom-loading" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "circular",
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M6 10.23C6 10.3791 5.879 10.5008 5.73015 10.4919C4.93498 10.4441 4.16496 10.186 3.49993 9.74161C2.75991 9.24715 2.18314 8.54434 1.84254 7.72207C1.50195 6.89981 1.41283 5.99501 1.58647 5.12209C1.7601 4.24918 2.18868 3.44736 2.81802 2.81802C3.44736 2.18868 4.24918 1.7601 5.12209 1.58647C5.99501 1.41283 6.89981 1.50195 7.72208 1.84254C8.54434 2.18314 9.24715 2.75991 9.74161 3.49993C10.186 4.16496 10.4441 4.93498 10.4919 5.73015C10.5008 5.879 10.3791 6 10.23 6C10.0809 6 9.96096 5.87897 9.9508 5.7302C9.9038 5.04192 9.67763 4.37615 9.29262 3.79994C8.85749 3.14872 8.23902 2.64116 7.51543 2.34144C6.79183 2.04171 5.99561 1.96329 5.22744 2.11609C4.45928 2.26889 3.75367 2.64604 3.19986 3.19986C2.64604 3.75367 2.26889 4.45928 2.11609 5.22744C1.96329 5.99561 2.04171 6.79183 2.34144 7.51543C2.64116 8.23902 3.14872 8.85749 3.79994 9.29262C4.37615 9.67763 5.04192 9.9038 5.7302 9.9508C5.87897 9.96096 6 10.0809 6 10.23Z",
      fill: "#2F68EB"
    })
  ])
], -1))
const _hoisted_17 = {
  src: _imports_1,
  alt: ""
}
const _hoisted_18 = {
  src: _imports_2,
  alt: ""
}
const _hoisted_19 = {
  key: 2,
  class: "videoType",
  style: {}
}
const _hoisted_20 = {
  key: 0,
  class: "videoWrapper",
  style: {"flex-direction":"column"}
}
const _hoisted_21 = { style: {"display":"flex"} }
const _hoisted_22 = { class: "borderRadius" }
const _hoisted_23 = ["src"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom-loading" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "circular",
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M6 10.23C6 10.3791 5.879 10.5008 5.73015 10.4919C4.93498 10.4441 4.16496 10.186 3.49993 9.74161C2.75991 9.24715 2.18314 8.54434 1.84254 7.72207C1.50195 6.89981 1.41283 5.99501 1.58647 5.12209C1.7601 4.24918 2.18868 3.44736 2.81802 2.81802C3.44736 2.18868 4.24918 1.7601 5.12209 1.58647C5.99501 1.41283 6.89981 1.50195 7.72208 1.84254C8.54434 2.18314 9.24715 2.75991 9.74161 3.49993C10.186 4.16496 10.4441 4.93498 10.4919 5.73015C10.5008 5.879 10.3791 6 10.23 6C10.0809 6 9.96096 5.87897 9.9508 5.7302C9.9038 5.04192 9.67763 4.37615 9.29262 3.79994C8.85749 3.14872 8.23902 2.64116 7.51543 2.34144C6.79183 2.04171 5.99561 1.96329 5.22744 2.11609C4.45928 2.26889 3.75367 2.64604 3.19986 3.19986C2.64604 3.75367 2.26889 4.45928 2.11609 5.22744C1.96329 5.99561 2.04171 6.79183 2.34144 7.51543C2.64116 8.23902 3.14872 8.85749 3.79994 9.29262C4.37615 9.67763 5.04192 9.9038 5.7302 9.9508C5.87897 9.96096 6 10.0809 6 10.23Z",
      fill: "#2F68EB"
    })
  ])
], -1))
const _hoisted_25 = {
  src: _imports_1,
  alt: ""
}
const _hoisted_26 = {
  src: _imports_2,
  alt: ""
}
const _hoisted_27 = {
  key: 0,
  class: "extraContent"
}
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "videoWrapper" }
const _hoisted_30 = { class: "borderRadius" }
const _hoisted_31 = { class: "errorImg" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_33 = { class: "errorTip" }
const _hoisted_34 = {
  key: 0,
  class: "extraContent"
}
const _hoisted_35 = {
  key: 3,
  class: "imageType"
}
const _hoisted_36 = { style: {"display":"flex"} }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image-slot" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: "",
    crossOrigin: "true"
  })
], -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom-loading" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "circular",
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M6 10.23C6 10.3791 5.879 10.5008 5.73015 10.4919C4.93498 10.4441 4.16496 10.186 3.49993 9.74161C2.75991 9.24715 2.18314 8.54434 1.84254 7.72207C1.50195 6.89981 1.41283 5.99501 1.58647 5.12209C1.7601 4.24918 2.18868 3.44736 2.81802 2.81802C3.44736 2.18868 4.24918 1.7601 5.12209 1.58647C5.99501 1.41283 6.89981 1.50195 7.72208 1.84254C8.54434 2.18314 9.24715 2.75991 9.74161 3.49993C10.186 4.16496 10.4441 4.93498 10.4919 5.73015C10.5008 5.879 10.3791 6 10.23 6C10.0809 6 9.96096 5.87897 9.9508 5.7302C9.9038 5.04192 9.67763 4.37615 9.29262 3.79994C8.85749 3.14872 8.23902 2.64116 7.51543 2.34144C6.79183 2.04171 5.99561 1.96329 5.22744 2.11609C4.45928 2.26889 3.75367 2.64604 3.19986 3.19986C2.64604 3.75367 2.26889 4.45928 2.11609 5.22744C1.96329 5.99561 2.04171 6.79183 2.34144 7.51543C2.64116 8.23902 3.14872 8.85749 3.79994 9.29262C4.37615 9.67763 5.04192 9.9038 5.7302 9.9508C5.87897 9.96096 6 10.0809 6 10.23Z",
      fill: "#2F68EB"
    })
  ])
], -1))
const _hoisted_39 = {
  src: _imports_1,
  alt: ""
}
const _hoisted_40 = {
  src: _imports_2,
  alt: ""
}
const _hoisted_41 = {
  key: 0,
  class: "extraContent"
}
const _hoisted_42 = { class: "errorImage" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  crossOrigin: "true"
}, null, -1))
const _hoisted_44 = { class: "errorTip" }
const _hoisted_45 = {
  key: 0,
  class: "extraContent"
}
const _hoisted_46 = {
  key: 4,
  class: "attachBox"
}
const _hoisted_47 = { class: "attachmentType" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = {
  key: 0,
  src: _imports_5,
  alt: ""
}
const _hoisted_50 = {
  key: 1,
  src: _imports_6,
  alt: ""
}
const _hoisted_51 = { key: 1 }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: ""
}, null, -1))
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = {
  key: 2,
  class: "textContent wordWrap wordRowsHidden"
}
const _hoisted_55 = {
  key: 3,
  class: "errorTip",
  style: {"margin-left":"10px"}
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom-loading" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "circular",
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M6 10.23C6 10.3791 5.879 10.5008 5.73015 10.4919C4.93498 10.4441 4.16496 10.186 3.49993 9.74161C2.75991 9.24715 2.18314 8.54434 1.84254 7.72207C1.50195 6.89981 1.41283 5.99501 1.58647 5.12209C1.7601 4.24918 2.18868 3.44736 2.81802 2.81802C3.44736 2.18868 4.24918 1.7601 5.12209 1.58647C5.99501 1.41283 6.89981 1.50195 7.72208 1.84254C8.54434 2.18314 9.24715 2.75991 9.74161 3.49993C10.186 4.16496 10.4441 4.93498 10.4919 5.73015C10.5008 5.879 10.3791 6 10.23 6C10.0809 6 9.96096 5.87897 9.9508 5.7302C9.9038 5.04192 9.67763 4.37615 9.29262 3.79994C8.85749 3.14872 8.23902 2.64116 7.51543 2.34144C6.79183 2.04171 5.99561 1.96329 5.22744 2.11609C4.45928 2.26889 3.75367 2.64604 3.19986 3.19986C2.64604 3.75367 2.26889 4.45928 2.11609 5.22744C1.96329 5.99561 2.04171 6.79183 2.34144 7.51543C2.64116 8.23902 3.14872 8.85749 3.79994 9.29262C4.37615 9.67763 5.04192 9.9038 5.7302 9.9508C5.87897 9.96096 6 10.0809 6 10.23Z",
      fill: "#2F68EB"
    })
  ])
], -1))
const _hoisted_57 = {
  src: _imports_1,
  alt: ""
}
const _hoisted_58 = {
  src: _imports_2,
  alt: ""
}
const _hoisted_59 = {
  key: 5,
  class: "systemType"
}
const _hoisted_60 = {
  key: 6,
  class: "locationType"
}
const _hoisted_61 = { class: "title" }
const _hoisted_62 = { class: "imgBox" }
const _hoisted_63 = {
  key: 0,
  src: _imports_8,
  alt: ""
}
const _hoisted_64 = {
  key: 1,
  src: _imports_9
}
const _hoisted_65 = { class: "name bname" }
const _hoisted_66 = {
  key: 7,
  class: "cardType"
}
const _hoisted_67 = { class: "title" }
const _hoisted_68 = { class: "cardBox" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_10,
  alt: ""
}, null, -1))
const _hoisted_70 = { class: "name" }
const _hoisted_71 = {
  key: 2,
  class: "publishTime"
}
const _hoisted_72 = {
  key: 1,
  class: "audioType"
}
const _hoisted_73 = {
  key: 0,
  class: "errorAudio"
}
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "errorImg"
}, null, -1))
const _hoisted_75 = { class: "errorTip wordRowsHidden" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom-loading" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "circular",
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M6 10.23C6 10.3791 5.879 10.5008 5.73015 10.4919C4.93498 10.4441 4.16496 10.186 3.49993 9.74161C2.75991 9.24715 2.18314 8.54434 1.84254 7.72207C1.50195 6.89981 1.41283 5.99501 1.58647 5.12209C1.7601 4.24918 2.18868 3.44736 2.81802 2.81802C3.44736 2.18868 4.24918 1.7601 5.12209 1.58647C5.99501 1.41283 6.89981 1.50195 7.72208 1.84254C8.54434 2.18314 9.24715 2.75991 9.74161 3.49993C10.186 4.16496 10.4441 4.93498 10.4919 5.73015C10.5008 5.879 10.3791 6 10.23 6C10.0809 6 9.96096 5.87897 9.9508 5.7302C9.9038 5.04192 9.67763 4.37615 9.29262 3.79994C8.85749 3.14872 8.23902 2.64116 7.51543 2.34144C6.79183 2.04171 5.99561 1.96329 5.22744 2.11609C4.45928 2.26889 3.75367 2.64604 3.19986 3.19986C2.64604 3.75367 2.26889 4.45928 2.11609 5.22744C1.96329 5.99561 2.04171 6.79183 2.34144 7.51543C2.64116 8.23902 3.14872 8.85749 3.79994 9.29262C4.37615 9.67763 5.04192 9.9038 5.7302 9.9508C5.87897 9.96096 6 10.0809 6 10.23Z",
      fill: "#2F68EB"
    })
  ])
], -1))
const _hoisted_77 = {
  src: _imports_1,
  alt: ""
}
const _hoisted_78 = {
  src: _imports_2,
  alt: ""
}
const _hoisted_79 = ["src"]
const _hoisted_80 = {
  key: 2,
  class: "videoType",
  style: {"flex-direction":"column"}
}
const _hoisted_81 = {
  key: 0,
  class: "videoWrapper",
  style: {"flex-direction":"column"}
}
const _hoisted_82 = { style: {"display":"flex"} }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom-loading" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "circular",
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M6 10.23C6 10.3791 5.879 10.5008 5.73015 10.4919C4.93498 10.4441 4.16496 10.186 3.49993 9.74161C2.75991 9.24715 2.18314 8.54434 1.84254 7.72207C1.50195 6.89981 1.41283 5.99501 1.58647 5.12209C1.7601 4.24918 2.18868 3.44736 2.81802 2.81802C3.44736 2.18868 4.24918 1.7601 5.12209 1.58647C5.99501 1.41283 6.89981 1.50195 7.72208 1.84254C8.54434 2.18314 9.24715 2.75991 9.74161 3.49993C10.186 4.16496 10.4441 4.93498 10.4919 5.73015C10.5008 5.879 10.3791 6 10.23 6C10.0809 6 9.96096 5.87897 9.9508 5.7302C9.9038 5.04192 9.67763 4.37615 9.29262 3.79994C8.85749 3.14872 8.23902 2.64116 7.51543 2.34144C6.79183 2.04171 5.99561 1.96329 5.22744 2.11609C4.45928 2.26889 3.75367 2.64604 3.19986 3.19986C2.64604 3.75367 2.26889 4.45928 2.11609 5.22744C1.96329 5.99561 2.04171 6.79183 2.34144 7.51543C2.64116 8.23902 3.14872 8.85749 3.79994 9.29262C4.37615 9.67763 5.04192 9.9038 5.7302 9.9508C5.87897 9.96096 6 10.0809 6 10.23Z",
      fill: "#2F68EB"
    })
  ])
], -1))
const _hoisted_84 = {
  src: _imports_1,
  alt: ""
}
const _hoisted_85 = {
  src: _imports_2,
  alt: ""
}
const _hoisted_86 = { class: "borderRadius" }
const _hoisted_87 = ["src"]
const _hoisted_88 = {
  key: 0,
  class: "extraContent"
}
const _hoisted_89 = { key: 1 }
const _hoisted_90 = { class: "videoWrapper" }
const _hoisted_91 = { class: "borderRadius" }
const _hoisted_92 = { class: "errorImg" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_94 = { class: "errorTip" }
const _hoisted_95 = {
  key: 0,
  class: "extraContent",
  style: {"margin-left":"0"}
}
const _hoisted_96 = {
  key: 3,
  class: "imageType"
}
const _hoisted_97 = { style: {"display":"flex"} }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom-loading" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "circular",
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M6 10.23C6 10.3791 5.879 10.5008 5.73015 10.4919C4.93498 10.4441 4.16496 10.186 3.49993 9.74161C2.75991 9.24715 2.18314 8.54434 1.84254 7.72207C1.50195 6.89981 1.41283 5.99501 1.58647 5.12209C1.7601 4.24918 2.18868 3.44736 2.81802 2.81802C3.44736 2.18868 4.24918 1.7601 5.12209 1.58647C5.99501 1.41283 6.89981 1.50195 7.72208 1.84254C8.54434 2.18314 9.24715 2.75991 9.74161 3.49993C10.186 4.16496 10.4441 4.93498 10.4919 5.73015C10.5008 5.879 10.3791 6 10.23 6C10.0809 6 9.96096 5.87897 9.9508 5.7302C9.9038 5.04192 9.67763 4.37615 9.29262 3.79994C8.85749 3.14872 8.23902 2.64116 7.51543 2.34144C6.79183 2.04171 5.99561 1.96329 5.22744 2.11609C4.45928 2.26889 3.75367 2.64604 3.19986 3.19986C2.64604 3.75367 2.26889 4.45928 2.11609 5.22744C1.96329 5.99561 2.04171 6.79183 2.34144 7.51543C2.64116 8.23902 3.14872 8.85749 3.79994 9.29262C4.37615 9.67763 5.04192 9.9038 5.7302 9.9508C5.87897 9.96096 6 10.0809 6 10.23Z",
      fill: "#2F68EB"
    })
  ])
], -1))
const _hoisted_99 = {
  src: _imports_1,
  alt: ""
}
const _hoisted_100 = {
  src: _imports_2,
  alt: ""
}
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image-slot" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: ""
  })
], -1))
const _hoisted_102 = {
  key: 0,
  class: "extraContent"
}
const _hoisted_103 = { class: "errorImage" }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  crossOrigin: "true"
}, null, -1))
const _hoisted_105 = { class: "errorTip" }
const _hoisted_106 = {
  key: 0,
  class: "extraContent",
  style: {"margin-left":"0"}
}
const _hoisted_107 = {
  key: 4,
  class: "attachBox"
}
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom-loading" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "circular",
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M6 10.23C6 10.3791 5.879 10.5008 5.73015 10.4919C4.93498 10.4441 4.16496 10.186 3.49993 9.74161C2.75991 9.24715 2.18314 8.54434 1.84254 7.72207C1.50195 6.89981 1.41283 5.99501 1.58647 5.12209C1.7601 4.24918 2.18868 3.44736 2.81802 2.81802C3.44736 2.18868 4.24918 1.7601 5.12209 1.58647C5.99501 1.41283 6.89981 1.50195 7.72208 1.84254C8.54434 2.18314 9.24715 2.75991 9.74161 3.49993C10.186 4.16496 10.4441 4.93498 10.4919 5.73015C10.5008 5.879 10.3791 6 10.23 6C10.0809 6 9.96096 5.87897 9.9508 5.7302C9.9038 5.04192 9.67763 4.37615 9.29262 3.79994C8.85749 3.14872 8.23902 2.64116 7.51543 2.34144C6.79183 2.04171 5.99561 1.96329 5.22744 2.11609C4.45928 2.26889 3.75367 2.64604 3.19986 3.19986C2.64604 3.75367 2.26889 4.45928 2.11609 5.22744C1.96329 5.99561 2.04171 6.79183 2.34144 7.51543C2.64116 8.23902 3.14872 8.85749 3.79994 9.29262C4.37615 9.67763 5.04192 9.9038 5.7302 9.9508C5.87897 9.96096 6 10.0809 6 10.23Z",
      fill: "#2F68EB"
    })
  ])
], -1))
const _hoisted_109 = {
  src: _imports_1,
  alt: ""
}
const _hoisted_110 = {
  src: _imports_2,
  alt: ""
}
const _hoisted_111 = { class: "attachmentType" }
const _hoisted_112 = { key: 0 }
const _hoisted_113 = {
  key: 0,
  src: _imports_5,
  alt: ""
}
const _hoisted_114 = {
  key: 1,
  src: _imports_6,
  alt: ""
}
const _hoisted_115 = { key: 1 }
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: ""
}, null, -1))
const _hoisted_117 = [
  _hoisted_116
]
const _hoisted_118 = {
  key: 2,
  class: "textContent wordWrap wordRowsHidden"
}
const _hoisted_119 = {
  key: 3,
  class: "errorTip",
  style: {"margin-left":"10px"}
}
const _hoisted_120 = {
  key: 5,
  class: "systemType"
}
const _hoisted_121 = {
  key: 6,
  class: "locationType"
}
const _hoisted_122 = { class: "title" }
const _hoisted_123 = { class: "imgBox" }
const _hoisted_124 = {
  key: 0,
  src: _imports_8,
  alt: ""
}
const _hoisted_125 = {
  key: 1,
  src: _imports_9
}
const _hoisted_126 = { class: "name bname" }
const _hoisted_127 = {
  key: 7,
  class: "cardType"
}
const _hoisted_128 = { class: "title" }
const _hoisted_129 = { class: "cardBox" }
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_10,
  alt: ""
}, null, -1))
const _hoisted_131 = { class: "name" }
const _hoisted_132 = { class: "publishTime" }
const _hoisted_133 = ["src"]
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_11,
  alt: "",
  class: "demoAvatar"
}, null, -1))
const _hoisted_135 = [
  _hoisted_134
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_image = _resolveComponent("el-image")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.message.bubble_time)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.message.bubble_time), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.layout === 'left' ? 'chatLeft' : 'chatRight'])
    }, [
      (_ctx.layout === 'left')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "leftItem",
            style: _normalizeStyle({ 'margin-top': _ctx.message.bubble_time ? '0' : '20px' })
          }, [
            (!_ctx.isVibe &&
        _ctx.message.avatar_url &&
        _ctx.message.send_side != _ctx.sendSide.systemSide
        )
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("img", {
                    src: _ctx.message.avatar_url,
                    alt: "",
                    class: "demoAvatar"
                  }, null, 8, _hoisted_4)
                ]))
              : (_ctx.message.send_side != _ctx.sendSide.systemSide)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_ctx.sessionClickItem &&
          _ctx.sessionClickItem.chat_type == 1 &&
          _ctx.message.send_side != _ctx.sendSide.systemSide
          )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.getFirstXLetters(_ctx.sessionClickItem.title, 3)), 1))
                      : _createCommentVNode("", true),
                    (_ctx.sessionClickItem &&
          _ctx.sessionClickItem.chat_type == 2 &&
          _ctx.message.send_side != _ctx.sendSide.systemSide
          )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.getFirstXLetters(_ctx.message.sender, 3)), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "chatInfo",
              style: _normalizeStyle({
        'justify-content':
          _ctx.message.send_side === _ctx.sendSide.systemSide ? 'center' : '',
        width: _ctx.message.send_side === _ctx.sendSide.systemSide ? '100%' : '',
      })
            }, [
              _createElementVNode("div", _hoisted_8, [
                (_ctx.sessionClickItem &&
            _ctx.sessionClickItem.chat_type == 1 &&
            _ctx.message.send_side != _ctx.sendSide.systemSide
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.sessionClickItem.title), 1))
                  : _createCommentVNode("", true),
                (_ctx.sessionClickItem &&
            _ctx.sessionClickItem.chat_type == 2 &&
            _ctx.message.send_side != _ctx.sendSide.systemSide
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.message.sender), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass([
            'content',
            _ctx.message.type == _ctx.chatType.image ||
              _ctx.message.type == _ctx.chatType.sticker ||
              _ctx.message.type == _ctx.chatType.gridChart ||
              _ctx.message.type == _ctx.chatType.video
              ? 'videoAndImage'
              : '',
          ]),
                  style: _normalizeStyle({
  padding:
    _ctx.message.type === 'text' ||
      _ctx.message.type === _ctx.chatType.onceImageOrVideo
      ? '8px'
      : '0px',
  alignSelf:
    _ctx.message.send_side == _ctx.sendSide.systemSide ? ' center' : '',
})
                }, [
                  ((_ctx.message.type === _ctx.chatType.text &&
  _ctx.message.send_side != _ctx.sendSide.systemSide) ||
  (_ctx.message.type === _ctx.chatType.onceImageOrVideo &&
    _ctx.message.send_side != _ctx.sendSide.systemSide)
  )
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "textType",
                        style: _normalizeStyle({
              padding:
                _ctx.message.send_side === _ctx.sendSide.systemSide ? '0' : '8px',
            })
                      }, _toDisplayString(_ctx.message.content), 5))
                    : _createCommentVNode("", true),
                  (_ctx.message.type === _ctx.chatType.audio ||
              _ctx.message.type === _ctx.chatType.voice
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        (!_ctx.message.oss_key || !_ctx.message.file_url)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              _hoisted_13,
                              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("chat.sentAudio")), 1)
                            ]))
                          : (_ctx.message.oss_key && _ctx.message.file_url)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("audio", {
                                  src: _ctx.message.file_url,
                                  controls: "",
                                  crossorigin: "true",
                                  class: "audio"
                                }, null, 8, _hoisted_15),
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  loading: _ctx.btnStatus == 'loading',
                                  class: "downloadBox",
                                  style: {"margin-left":"8px"},
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.downloadAnyFile(_ctx.message.file_url, _ctx.message.file_name)))
                                }, {
                                  loading: _withCtx(() => [
                                    _hoisted_16
                                  ]),
                                  default: _withCtx(() => [
                                    _withDirectives(_createElementVNode("img", _hoisted_17, null, 512), [
                                      [_vShow, _ctx.btnStatus == 'default']
                                    ]),
                                    _withDirectives(_createElementVNode("img", _hoisted_18, null, 512), [
                                      [_vShow, _ctx.btnStatus == 'focus']
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["loading"])
                              ], 64))
                            : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.message.type === _ctx.chatType.video || _ctx.message.type === _ctx.chatType.gif
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        (_ctx.message.file_url)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("div", _hoisted_22, [
                                  _createElementVNode("video", {
                                    src: _ctx.message.file_url,
                                    id: "video",
                                    style: {"width":"100%","height":"100%","object-fit":"fill"},
                                    controls: "",
                                    crossOrigin: "true"
                                  }, null, 8, _hoisted_23)
                                ]),
                                (_ctx.message.file_url)
                                  ? (_openBlock(), _createBlock(_component_el_button, {
                                      key: 0,
                                      type: "primary",
                                      loading: _ctx.btnStatus == 'loading',
                                      class: "downloadBox",
                                      style: {"margin-left":"8px"},
                                      onClick: _cache[1] || (_cache[1] = ($event: any) => (
                      _ctx.downloadAnyFile(_ctx.message.file_url, _ctx.message.file_name)
                      ))
                                    }, {
                                      loading: _withCtx(() => [
                                        _hoisted_24
                                      ]),
                                      default: _withCtx(() => [
                                        _withDirectives(_createElementVNode("img", _hoisted_25, null, 512), [
                                          [_vShow, _ctx.btnStatus == 'default']
                                        ]),
                                        _withDirectives(_createElementVNode("img", _hoisted_26, null, 512), [
                                          [_vShow, _ctx.btnStatus == 'focus']
                                        ])
                                      ]),
                                      _: 1
                                    }, 8, ["loading"]))
                                  : _createCommentVNode("", true)
                              ]),
                              (_ctx.message.content)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.message.content), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("div", _hoisted_30, [
                                  _createElementVNode("div", _hoisted_31, [
                                    _hoisted_32,
                                    _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t("chat.sentFile")), 1)
                                  ])
                                ])
                              ]),
                              (_ctx.message.content)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_ctx.message.content), 1))
                                : _createCommentVNode("", true)
                            ]))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.message.type === _ctx.chatType.image ||
              _ctx.message.type === _ctx.chatType.sticker ||
              _ctx.message.type === _ctx.chatType.gridChart
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        (_ctx.message.oss_key && _ctx.message.file_name)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("div", _hoisted_36, [
                                _createVNode(_component_el_image, {
                                  class: "imageBorder",
                                  src: _ctx.message.file_url,
                                  "initial-index": 0,
                                  ref: "previewImg",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (
                    _ctx.handleImageClick(_ctx.message.file_url, _ctx.message.file_name)
                    )),
                                  "preview-src-list": [_ctx.message.file_url],
                                  fit: "contain",
                                  "hide-on-click-modal": true
                                }, {
                                  error: _withCtx(() => [
                                    _hoisted_37
                                  ]),
                                  _: 1
                                }, 8, ["src", "preview-src-list"]),
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  loading: _ctx.btnStatus == 'loading',
                                  class: "downloadBox",
                                  style: {"margin-left":"8px"},
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (
                      _ctx.downloadAnyFile(_ctx.message.file_url, _ctx.message.file_name)
                      ))
                                }, {
                                  loading: _withCtx(() => [
                                    _hoisted_38
                                  ]),
                                  default: _withCtx(() => [
                                    _withDirectives(_createElementVNode("img", _hoisted_39, null, 512), [
                                      [_vShow, _ctx.btnStatus == 'default']
                                    ]),
                                    _withDirectives(_createElementVNode("img", _hoisted_40, null, 512), [
                                      [_vShow, _ctx.btnStatus == 'focus']
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["loading"])
                              ]),
                              (_ctx.message.content)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(_ctx.message.content), 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("div", _hoisted_42, [
                                _hoisted_43,
                                _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.$t("chat.sentFile")), 1)
                              ]),
                              (_ctx.message.content)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(_ctx.message.content), 1))
                                : _createCommentVNode("", true)
                            ], 64))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.message.type === _ctx.chatType.file)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                          (_ctx.fileStatus != 'loading')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                (_ctx.message.oss_key && _ctx.message.file_url)
                                  ? (_openBlock(), _createElementBlock("img", _hoisted_49))
                                  : (!_ctx.message.oss_key || !_ctx.message.file_url)
                                    ? (_openBlock(), _createElementBlock("img", _hoisted_50))
                                    : _createCommentVNode("", true)
                              ]))
                            : (_ctx.fileStatus == 'loading')
                              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_51, _hoisted_53)), [
                                  [_directive_loading, true]
                                ])
                              : _createCommentVNode("", true),
                          (_ctx.message.file_name)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_54, _toDisplayString(_ctx.message.file_name), 1))
                            : _createCommentVNode("", true),
                          (!_ctx.message.file_name)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_55, _toDisplayString(_ctx.$t("chat.sentFile")), 1))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.message.oss_key && _ctx.message.file_url)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              type: "primary",
                              loading: _ctx.btnStatus == 'loading',
                              class: "downloadBox",
                              style: {"margin-left":"8px"},
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.downloadAnyFile(_ctx.message.file_url, _ctx.message.file_name)))
                            }, {
                              loading: _withCtx(() => [
                                _hoisted_56
                              ]),
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("img", _hoisted_57, null, 512), [
                                  [_vShow, _ctx.btnStatus == 'default']
                                ]),
                                _withDirectives(_createElementVNode("img", _hoisted_58, null, 512), [
                                  [_vShow, _ctx.btnStatus == 'focus']
                                ])
                              ]),
                              _: 1
                            }, 8, ["loading"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.message.send_side === _ctx.sendSide.systemSide)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_59, _toDisplayString(_ctx.message.content), 1))
                    : _createCommentVNode("", true),
                  (_ctx.message.type === _ctx.chatType.location)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.$t("chat.location").replace("[", "").replace("]", "")), 1),
                        _createElementVNode("div", _hoisted_62, [
                          (!_ctx.message.content)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_63))
                            : (_openBlock(), _createElementBlock("img", _hoisted_64))
                        ]),
                        _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.message.content), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.message.type === _ctx.chatType.card)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                        _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.$t("chat.contactCard").replace("[", "").replace("]", "")), 1),
                        _createElementVNode("div", _hoisted_68, [
                          _hoisted_69,
                          _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.message.content), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 6),
                (_ctx.message.send_side != _ctx.sendSide.systemSide)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_71, _toDisplayString(_ctx.dateFormat(_ctx.message.date, "YYYY-MM-DD HH:mm") || "--"), 1))
                  : _createCommentVNode("", true)
              ])
            ], 4)
          ], 4))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "rightItem",
            style: _normalizeStyle({ 'margin-top': _ctx.message.bubble_time ? '0' : '20px' })
          }, [
            _createElementVNode("div", {
              class: "chatInfo",
              style: _normalizeStyle({
        'justify-content':
          _ctx.message.send_side === _ctx.sendSide.systemSide || _ctx.message.bubble_time
            ? 'center'
            : '',
        width: _ctx.message.send_side === _ctx.sendSide.systemSide ? '100%' : '',
      })
            }, [
              _createElementVNode("div", {
                class: _normalizeClass([
          'content',
          _ctx.message.type == _ctx.chatType.image ||
            _ctx.message.type === _ctx.chatType.sticker ||
            _ctx.message.type === _ctx.chatType.gridChart ||
            _ctx.message.type == _ctx.chatType.video
            ? 'videoAndImage'
            : '',
        ]),
                style: _normalizeStyle({
  padding:
    _ctx.message.type === _ctx.chatType.text ||
      _ctx.message.type === _ctx.chatType.onceImageOrVideo
      ? '0px'
      : '0px',
  alignSelf:
    _ctx.message.send_side == _ctx.sendSide.systemSide ? ' center' : '',
})
              }, [
                ((_ctx.message.type === _ctx.chatType.text &&
  _ctx.message.send_side != _ctx.sendSide.systemSide) ||
  (_ctx.message.type === _ctx.chatType.onceImageOrVideo &&
    _ctx.message.send_side != _ctx.sendSide.systemSide)
  )
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "textType",
                      style: _normalizeStyle({
            padding: _ctx.message.send_side === _ctx.sendSide.systemSide ? '0' : '8px',
          })
                    }, _toDisplayString(_ctx.message.content), 5))
                  : _createCommentVNode("", true),
                (_ctx.message.type === _ctx.chatType.audio || _ctx.message.type === _ctx.chatType.voice
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                      (!_ctx.message.oss_key || !_ctx.message.file_url)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                            _hoisted_74,
                            _createElementVNode("div", _hoisted_75, _toDisplayString(_ctx.$t("chat.sentAudio")), 1)
                          ]))
                        : (_ctx.message.oss_key && _ctx.message.file_url)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                loading: _ctx.btnStatus == 'loading',
                                class: "downloadBox",
                                style: {"margin-left":"8px"},
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.downloadAnyFile(_ctx.message.file_url, _ctx.message.file_name)))
                              }, {
                                loading: _withCtx(() => [
                                  _hoisted_76
                                ]),
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("img", _hoisted_77, null, 512), [
                                    [_vShow, _ctx.btnStatus == 'default']
                                  ]),
                                  _withDirectives(_createElementVNode("img", _hoisted_78, null, 512), [
                                    [_vShow, _ctx.btnStatus == 'focus']
                                  ])
                                ]),
                                _: 1
                              }, 8, ["loading"]),
                              _createElementVNode("audio", {
                                src: _ctx.message.file_url,
                                controls: "",
                                crossorigin: "true",
                                class: "audio"
                              }, null, 8, _hoisted_79)
                            ], 64))
                          : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.message.type === _ctx.chatType.video || _ctx.message.type === _ctx.chatType.gif
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                      (_ctx.message.file_url)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                            _createElementVNode("div", _hoisted_82, [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                loading: _ctx.btnStatus == 'loading',
                                class: "downloadBox",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.downloadAnyFile(_ctx.message.file_url, _ctx.message.file_name)))
                              }, {
                                loading: _withCtx(() => [
                                  _hoisted_83
                                ]),
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("img", _hoisted_84, null, 512), [
                                    [_vShow, _ctx.btnStatus == 'default']
                                  ]),
                                  _withDirectives(_createElementVNode("img", _hoisted_85, null, 512), [
                                    [_vShow, _ctx.btnStatus == 'focus']
                                  ])
                                ]),
                                _: 1
                              }, 8, ["loading"]),
                              _createElementVNode("div", _hoisted_86, [
                                _createElementVNode("video", {
                                  src: _ctx.message.file_url,
                                  id: "video",
                                  style: {"width":"100%","height":"100%","object-fit":"fill"},
                                  controls: "",
                                  crossOrigin: "true",
                                  onError: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleVideoError && _ctx.handleVideoError(...args)))
                                }, null, 40, _hoisted_87)
                              ])
                            ]),
                            (_ctx.message.content)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_88, _toDisplayString(_ctx.message.content), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_89, [
                            _createElementVNode("div", _hoisted_90, [
                              _createElementVNode("div", _hoisted_91, [
                                _createElementVNode("div", _hoisted_92, [
                                  _hoisted_93,
                                  _createElementVNode("div", _hoisted_94, _toDisplayString(_ctx.$t("chat.sentFile")), 1)
                                ])
                              ])
                            ]),
                            (_ctx.message.content)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_95, _toDisplayString(_ctx.message.content), 1))
                              : _createCommentVNode("", true)
                          ]))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.message.type === _ctx.chatType.image ||
            _ctx.message.type === _ctx.chatType.sticker ||
            _ctx.message.type === _ctx.chatType.gridChart
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                      (_ctx.message.oss_key && _ctx.message.file_name)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("div", _hoisted_97, [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                loading: _ctx.btnStatus == 'loading',
                                class: "downloadBox",
                                style: {"margin-left":"8px"},
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.downloadAnyFile(_ctx.message.file_url, _ctx.message.file_name)))
                              }, {
                                loading: _withCtx(() => [
                                  _hoisted_98
                                ]),
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("img", _hoisted_99, null, 512), [
                                    [_vShow, _ctx.btnStatus == 'default']
                                  ]),
                                  _withDirectives(_createElementVNode("img", _hoisted_100, null, 512), [
                                    [_vShow, _ctx.btnStatus == 'focus']
                                  ])
                                ]),
                                _: 1
                              }, 8, ["loading"]),
                              _createVNode(_component_el_image, {
                                class: "imageBorder",
                                src: _ctx.message.file_url,
                                "initial-index": 0,
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleImageClick(_ctx.message.file_url, _ctx.message.file_name))),
                                "preview-src-list": [_ctx.message.file_url],
                                fit: "contain",
                                "hide-on-click-modal": true
                              }, {
                                error: _withCtx(() => [
                                  _hoisted_101
                                ]),
                                _: 1
                              }, 8, ["src", "preview-src-list"])
                            ]),
                            (_ctx.message.content)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_102, _toDisplayString(_ctx.message.content), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("div", _hoisted_103, [
                              _hoisted_104,
                              _createElementVNode("div", _hoisted_105, _toDisplayString(_ctx.$t("chat.sentFile")), 1)
                            ]),
                            (_ctx.message.content)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_106, _toDisplayString(_ctx.message.content), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.message.type === _ctx.chatType.file)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                      (_ctx.message.oss_key && _ctx.message.file_url)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            type: "primary",
                            loading: _ctx.btnStatus == 'loading',
                            class: "downloadBox",
                            style: {"margin-left":"8px"},
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.downloadAnyFile(_ctx.message.file_url, _ctx.message.file_name)))
                          }, {
                            loading: _withCtx(() => [
                              _hoisted_108
                            ]),
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("img", _hoisted_109, null, 512), [
                                [_vShow, _ctx.btnStatus == 'default']
                              ]),
                              _withDirectives(_createElementVNode("img", _hoisted_110, null, 512), [
                                [_vShow, _ctx.btnStatus == 'focus']
                              ])
                            ]),
                            _: 1
                          }, 8, ["loading"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_111, [
                        (_ctx.fileStatus != 'loading')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                              (_ctx.message.oss_key && _ctx.message.file_url)
                                ? (_openBlock(), _createElementBlock("img", _hoisted_113))
                                : (!_ctx.message.oss_key || !_ctx.message.file_url)
                                  ? (_openBlock(), _createElementBlock("img", _hoisted_114))
                                  : _createCommentVNode("", true)
                            ]))
                          : (_ctx.fileStatus == 'loading')
                            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_115, _hoisted_117)), [
                                [_directive_loading, true]
                              ])
                            : _createCommentVNode("", true),
                        (_ctx.message.file_name)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_118, _toDisplayString(_ctx.message.file_name), 1))
                          : _createCommentVNode("", true),
                        (!_ctx.message.file_name)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_119, _toDisplayString(_ctx.$t("chat.sentFile")), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.message.send_side === _ctx.sendSide.systemSide)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_120, _toDisplayString(_ctx.message.content), 1))
                  : _createCommentVNode("", true),
                (_ctx.message.type === _ctx.chatType.location)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                      _createElementVNode("div", _hoisted_122, _toDisplayString(_ctx.$t("chat.location").replace("[", "").replace("]", "")), 1),
                      _createElementVNode("div", _hoisted_123, [
                        (!_ctx.message.content)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_124))
                          : (_openBlock(), _createElementBlock("img", _hoisted_125))
                      ]),
                      _createElementVNode("div", _hoisted_126, _toDisplayString(_ctx.message.content), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.message.type === _ctx.chatType.card)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                      _createElementVNode("div", _hoisted_128, _toDisplayString(_ctx.$t("chat.contactCard").replace("[", "").replace("]", "")), 1),
                      _createElementVNode("div", _hoisted_129, [
                        _hoisted_130,
                        _createElementVNode("div", _hoisted_131, _toDisplayString(_ctx.message.content), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 6),
              _createElementVNode("div", _hoisted_132, _toDisplayString(_ctx.dateFormat(_ctx.message.date, "YYYY-MM-DD HH:mm") || "--"), 1)
            ], 4),
            (!_ctx.isVibe && _ctx.message.avatar_url)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.message.avatar_url,
                  alt: "",
                  style: {"align-self":"flex-start","margin-left":"2px","position":"relative","top":"-5px"},
                  class: "demoAvatar"
                }, null, 8, _hoisted_133))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(['avatar', _ctx.message.type === _ctx.chatType.text ? 'offsetTop' : ''])
                }, _hoisted_135, 2))
          ], 4))
    ], 2)
  ], 64))
}